interface AnalyticsServiceInterface {
    init(): void;
    pushDataLayerEvent(args: Record<string, unknown> & { event: string }): void;
}

export class AnalyticsService implements AnalyticsServiceInterface {
    private gtmContainerId: string;
    private sfAccountId: string;

    constructor(gtmContainerId: string, sfAccountId: string) {
        this.sfAccountId = sfAccountId;
        this.gtmContainerId = gtmContainerId;
    }

    private appendNoScriptElement(): void {
        const iframe = document.createElement('iframe');
        const noScript = document.createElement('noscript');

        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtmContainerId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.title = 'Google Tag Manager';
        noScript.appendChild(iframe);
        document.body.appendChild(noScript);
    }

    private initScript(): void {
        (function (
            w: Window & { dataLayer: Record<string, unknown>[] },
            d: Document,
            s: 'script',
            l: 'dataLayer',
            i: string
        ) {
            w[l] = w[l] || [];

            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement<'script'>(s);
            const dl = l != 'dataLayer' ? '&l=' + l : '';
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode?.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', this.gtmContainerId);
    }

    private initCustomGtmData(): void {
        if (typeof window !== 'undefined') {
            window.__GTMData = {
                sfAccountId: this.sfAccountId || '',
            };
        }
    }

    init(): void {
        if (!window.dataLayer) {
            this.initScript();
            this.appendNoScriptElement();
            this.initCustomGtmData();
        }
    }

    pushDataLayerEvent(
        args: Record<string, unknown> & { event: string }
    ): void {
        const dataLayer = window.dataLayer;
        if (!dataLayer) {
            console.warn('GTM dataLayer not found');
            return;
        }
        dataLayer.push({ ...args });
    }
}
